import {Injectable} from '@angular/core';
import {Item} from "../../models/Item";
import {ToolsService} from "../toolsService/tools.service";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {CalculateInputsService} from "../calculateInputsService/calculate-inputs.service";
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";

@Injectable({
  providedIn: 'root'
})
export class DxfImportService {

  constructor(
    private toolsService: ToolsService,
    private view: CesiumAdapterService,
    private itemManager: ItemManagerService,
    private calculateItemInputsService: CalculateInputsService,
    private uiAdapterService: UiAdapterService
  ) {

    window['dxfImport'] = () => {
      let $ = jQuery;
      $.ajax({
        url: '/files.json',
        dataType: 'json',
        success: (data) => {
          console.log('DXF', data);
          this.addDxfData(data, 0);
        }
      });
    };

    Math.tanh = Math.tanh || function(x) {
      if(x === Infinity) {
        return 1;
      } else if(x === -Infinity) {
        return -1;
      } else {
        return (Math.exp(x) - Math.exp(-x)) / (Math.exp(x) + Math.exp(-x));
      }
    };

    Math.atanh = Math.atanh || function(x) {
      return Math.log((1+x)/(1-x)) / 2;
    };
  }

  convertArray(coordinates) {
    let n = [];
    for (let i = 0; i < coordinates.length; i++) {
      n.push(this.lambert93toWGPS(coordinates[i][0], coordinates[i][1]));
    }
    return n;
  }

  lambert93toWGPS(lambertE, lambertN) {

    var constantes = {
      GRS80E: 0.081819191042816,
      LONG_0: 3,
      XS: 700000,
      YS: 12655612.0499,
      n: 0.7256077650532670,
      C: 11754255.4261
    }

    var delX = lambertE - constantes.XS;
    var delY = lambertN - constantes.YS;
    var gamma = Math.atan(-delX / delY);
    var R = Math.sqrt(delX * delX + delY * delY);
    var latiso = Math.log(constantes.C / R) / constantes.n;
    var sinPhiit0 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * Math.sin(1)));
    var sinPhiit1 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit0));
    var sinPhiit2 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit1));
    var sinPhiit3 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit2));
    var sinPhiit4 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit3));
    var sinPhiit5 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit4));
    var sinPhiit6 = Math.tanh(latiso + constantes.GRS80E * Math.atanh(constantes.GRS80E * sinPhiit5));

    var longRad = Math.asin(sinPhiit6);
    var latRad = gamma / constantes.n + constantes.LONG_0 / 180 * Math.PI;

    var longitude = latRad / Math.PI * 180;
    var latitude = longRad / Math.PI * 180;

    return {lng: longitude, lat: latitude};
  }

  addDxfData(data, i) {
    if (i >= data.length) {
      return;
    }
    let obj = data[i];
    let tool = null;
    if (obj.type == 'HATCH') {
      tool = this.toolsService.getToolById(55);
    } else if (obj.type == 'LWPOLYLINE') {
      tool = this.toolsService.getToolById(56);
    } else {
      throw new Error('Unknown dxf entity: ' + obj.type);
    }
    obj.coordinates = this.convertArray(obj.coordinates);
    this.view.drawingTool.setTool(tool);
    let promise = this.itemManager.addDrawnItem({
      tool: tool,
      position: obj.coordinates,
      radius: null
    });
    promise.then((item:Item)=>{
      item.config.createInputValue('layer', {label: 'DWG Layer', value: obj.layer});
      item.config.createInputValue('handle', {label: 'DWG Handle', value: obj.handle});
      this.calculateItemInputsService.calculateItemInputs(item);

      item.drag_enabled = true;
      if (!this.uiAdapterService.globalDragEnabled) {
        item.timer = setTimeout(() => {
          item.drag_enabled = false;
          item.timer = null;
          this.itemManager.isDragTriggered = true;
        }, 30000);
      }
      this.addDxfData(data, i + 1);
    })
      .catch((response)=>{
        console.error('Can\'t add object => ', response);
      })
  }

}
